/**
 * Analytics Components Index
 * 
 * To add a new tab:
 * 1. Create <TabName>Tab.js in this folder
 * 2. Export it here
 * 3. Add to TAB_COMPONENTS map
 * 4. Update analyticsConfig.js
 */

export { default as ProfitabilityTab } from "./ProfitabilityTab";
export { default as LaborTab } from "./LaborTab";
export { default as MaterialsTab } from "./MaterialsTab";
export { default as RevenueTab } from "./RevenueTab";
export { default as EmployeesTab } from "./EmployeesTab";
export { default as SeasonalTab } from "./SeasonalTab";
export * from "./shared";

// Map tab IDs to components for dynamic rendering
export const TAB_COMPONENTS = {
  profitability: require("./ProfitabilityTab").default,
  labor: require("./LaborTab").default,
  materials: require("./MaterialsTab").default,
  revenue: require("./RevenueTab").default,
  employees: require("./EmployeesTab").default,
  seasonal: require("./SeasonalTab").default,
};

// Get component by tab ID
export const getTabComponent = (tabId) => TAB_COMPONENTS[tabId] || null;
